import Router from 'next/router';
import { IMeeting, ParticipantMeetingState } from '../../../../interfaces';
import {
  ADD_PRODUCT_TO_COMPARE,
  CLICK_PRODUCT_COLOR,
  DID_SLIDE_PRODUCT_IMAGES_SLIDER,
  POPUP_DID_LOAD_PAGE,
  POPUP_DID_SCROLL_PAGE,
  REMOVE_PRODUCT_FROM_COMPARE,
  UPDATE_PRODUCT_SEARCH_STATE,
  SHOW_PRODUCT_DESCRIPTION,
  SHOW_PRODUCT_SPECIFICATIONS,
  UPDATE_STORY_SEARCH_STATE,
  SELECT_PRODUCT_STRAP,
  SELECT_PRODUCT_BUCKLE,
  FOCUS_ITEM,
  ADVISOR_ADD_TO_WISH_LIST,
  SET_AUDIO_OUTPUT,
  DID_CHANGE_WISHLIST_TAB,
  SET_PRODUCT_AR_VIEWER,
  UPDATE_STORYBOOK_INDEX
} from '../../../../redux/actions';
import { actionAddToWishlistAsync } from '../../../../redux/asyncActions';
import {
  getVerticalScrollRange,
  performScroll
} from '../../../../utils/window';

const handlePopupDidLoadPage = (event: MessageEvent) => {
  console.log(`POPUP_DID_LOAD_PAGE ${event.data.payload}`);
  const components = event.data.payload.split('/');
  const query = event.data.payload.split('?')?.[1];
  const attributes = `${query ? '?' + query : ''}`;
  if (components.length >= 2) {
    if (components[1].startsWith('wishlist')) {
      Router.push(`/${components[1]}`, event.data.payload);
    } else {
      Router.push(`/${components[1]}/[id]${attributes}`, event.data.payload);
    }
  }
};

const handlePopupDidScrollPage = (event: MessageEvent) => {
  console.log(`POPUP_DID_SCROLL_PAGE ${event.data.payload}`);
  const scrolledPercentage = parseFloat(event.data.payload);
  if (!isNaN(scrolledPercentage)) {
    const totalYScrollRange = getVerticalScrollRange();
    performScroll({
      top: totalYScrollRange * scrolledPercentage,
      left: 0,
      behavior: 'smooth'
    });
  }
};

export const popupHandleMessageFromVB = (
  event: MessageEvent,
  meeting: IMeeting | undefined,
  dispatch: Function
) => {
  if (
    meeting?.state === ParticipantMeetingState.ENTERED_FROM_LOUNGE ||
    event.origin !== `${location.protocol}//${location.host}`
  ) {
    return;
  }
  console.log('popupHandleMessageFromVB - received event from VB for iframe:');
  console.log(event.data);
  switch (event.data.type) {
    case POPUP_DID_LOAD_PAGE:
      handlePopupDidLoadPage(event);
      break;
    case POPUP_DID_SCROLL_PAGE:
      handlePopupDidScrollPage(event);
      break;
    case ADVISOR_ADD_TO_WISH_LIST: {
      const { storeId, brandId, item } = event.data?.payload || {};
      dispatch(actionAddToWishlistAsync(item, storeId, brandId));
      break;
    }
    case SET_AUDIO_OUTPUT:
    case DID_SLIDE_PRODUCT_IMAGES_SLIDER:
    case CLICK_PRODUCT_COLOR:
    case SHOW_PRODUCT_DESCRIPTION:
    case SHOW_PRODUCT_SPECIFICATIONS:
    case ADD_PRODUCT_TO_COMPARE:
    case FOCUS_ITEM:
    case UPDATE_PRODUCT_SEARCH_STATE:
    case UPDATE_STORY_SEARCH_STATE:
    case SELECT_PRODUCT_STRAP:
    case SELECT_PRODUCT_BUCKLE:
    case DID_CHANGE_WISHLIST_TAB:
    case SET_PRODUCT_AR_VIEWER:
    case UPDATE_STORYBOOK_INDEX:
    case REMOVE_PRODUCT_FROM_COMPARE: {
      console.log(`dispatching action from event.data`);
      dispatch(event.data);
      break;
    }
    default:
      break;
  }
};
